
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/crypto-wallet",
      function () {
        return require("private-next-pages/crypto-wallet/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/crypto-wallet"])
      });
    }
  